import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "./shared";

export const FloatingWhatsApp = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 480);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-btn"
            aria-label="Chat with Afrinexa Global on WhatsApp"
            className={`fixed bottom-5 right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-forest text-ivory shadow-lg shadow-ink/20 transition-all duration-500 hover:bg-forest-deep sm:bottom-6 sm:right-6 sm:h-14 sm:w-14 ${
                visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
            }`}
        >
            <MessageCircle size={22} strokeWidth={1.5} />
        </a>
    );
};
